import request from 'utils/request';
const axios: any = new request('leadbest-official-website').request;

export async function postContact(payload: any): Promise<any> {
    return axios.post(`/items/contacts`, payload);
}

export async function postEmail(payload: any): Promise<any> {
    return axios.post(`/items/subscriptions`, payload);
}

export async function getBanner(payload: any): Promise<any> {
    return axios.get(`/items/banners?fields[]=name,file.*,link`, payload);
}